import React from 'react';
import PropTypes from 'prop-types';
import { Button, Image, Title } from './styles';

const UploadButton = (props) => {
  const {
    text,
    handleOpenUploader,
  } = props;

  return (
    <Button onClick={handleOpenUploader} data-uploader>
      <Image src="/images/upload-icon.png" alt="Upload Logo" />
      <Title>
        {text}
      </Title>
    </Button>
  );
};

UploadButton.propTypes = {
  text: PropTypes.string.isRequired,
  handleOpenUploader: PropTypes.func.isRequired,
};

export default UploadButton;
